// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"3b099bd4","208":"606a6e78","408":"9c27a326","592":"5d9a7bb9","928":"7417df2d"}[chunkId] + ".chunk.js";
};